import { Input, Button, Form, Toast, NavBar } from 'antd-mobile'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons'
import { useAuth } from '../../app/providers/AuthProvider'
import { authApi } from '../../features/auth/api/authApi'


export default function UpdatePassword() {


    const { memberInfo, signOut } = useAuth()


    //跳转
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false)
    const [visibleAgain, setVisibleAgain] = useState(false)

    const validatePassword = (_, value) => {
        if (!value) {
            return Promise.reject('请输入密码')
        }
        return Promise.resolve()
    }

    const validateConfirmPassword = (_, value) => {
        const password = form.getFieldValue('password'); // Accessing password field value using form instance
        if (value !== password) {
            return Promise.reject('两次输入密码不一致');
        }
        return Promise.resolve();
    };


    return (
        <div className="auth-container has-unified-nav ui-page ui-page--with-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                修改密码
            </NavBar>
            <div className='info_detail ui-page__content'>
                <Form layout='horizontal' mode='card'
                    footer={
                        <Button block type='submit' size='large' color='primary'>
                            提交
                        </Button>
                    }
                    onFinish={(values) => {

                        const formData = new FormData();
                        formData.append('password', values.password);
                        formData.append('passwordAgain', values.passwordAgain);
                        formData.append('memberId', memberInfo.orgId)

                        authApi.updatePassword(formData).then(function (response) {
                            if (response.data.code === 200) {
                                Toast.show({
                                    icon: 'success',
                                    content: "修改成功！"
                                })
                                // 修改密码后只清理认证信息，保留其他业务缓存。
                                signOut();
                                navigate('/login')
                            } else {
                                Toast.show({
                                    icon: 'fail',
                                    content: response.data.msg
                                })
                            }
                        })
                            .catch(function () {
                                Toast.show({
                                    icon: 'fail',
                                    content: "服务错误！请联系管理员！"
                                })
                            })
                            .finally(() => {
                            });
                    }}
                    form={form}
                >
                    <Form.Header>修改密码</Form.Header>
                    <Form.Item label='密码' name='password' rules={[
                        { validator: validatePassword }
                    ]}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input
                                style={{ flex: 'auto' }}
                                placeholder='请输入密码'
                                type={visible ? 'text' : 'password'}
                                clearable
                            />
                            <div style={{ flex: 'none', marginLeft: '8px', padding: '4px', cursor: 'pointer' }}>
                                {!visible ? (
                                    <EyeInvisibleOutline onClick={() => setVisible(true)} />
                                ) : (
                                    <EyeOutline onClick={() => setVisible(false)} />
                                )}
                            </div>
                        </div>
                    </Form.Item>
                    <Form.Item label='确认密码' name='passwordAgain' rules={[
                        { validator: validatePassword },
                        { validator: validateConfirmPassword }
                    ]}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input
                                style={{ flex: 'auto' }}
                                placeholder='请输入密码'
                                type={visibleAgain ? 'text' : 'password'}
                                clearable
                            />
                            <div style={{ flex: 'none', marginLeft: '8px', padding: '4px', cursor: 'pointer' }}>
                                {!visibleAgain ? (
                                    <EyeInvisibleOutline onClick={() => setVisibleAgain(true)} />
                                ) : (
                                    <EyeOutline onClick={() => setVisibleAgain(false)} />
                                )}
                            </div>
                        </div>
                    </Form.Item>

                </Form>
            </div>
        </div>
    )
}
